export default {
  heading1: { en: "Discover the Beauty of", he: "להראות טוב בכל גיל עם " },
  heading2: { en: "Aesthetic Medicine", he: "רפואה אסתטית" },
  description: {
    en: "Our website offers a wide range of aesthetic treatments to help you achieve your desired look and boost your confidence. Browse our site to learn more and find the perfect solution for you.",
    he: 'ד"ר מעין רחמים מציע מגוון טיפולים אסתטיים שיסייעו לך להשיג את התוצאות הרצויות והנכונות ביותר עבורך.  בלונה קליניק אנו דוגלים בהתאמה אישית לכל מטופל/ת ומתחייבים בשימוש בחומרים האיכותיים והבטוחים ביותר הקיימים. ',
  },
  detailsBtn: { en: "Get to know more details", he: "לפרטים נוספים" },
};
